import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-add\"><path d=\"M663.7056 725.504h-0.512a39.8848 39.8848 0 0 0 0.512 79.872h208.896a39.9872 39.9872 0 0 0-0.512-79.872h-208.384z\" fill=\"#FFFFFF\" p-id=\"2003\" /><path d=\"M807.8336 654.336v-0.512a39.8848 39.8848 0 0 0-79.872 0.512v208.896a39.9872 39.9872 0 0 0 79.872-0.512v-208.384zM151.04 153.6h-0.512a39.8848 39.8848 0 0 0 0.512 79.872h720.896A39.9872 39.9872 0 0 0 871.424 153.6H151.04zM151.04 409.6h-0.512a39.8848 39.8848 0 0 0 0.512 79.872h567.296A39.9872 39.9872 0 0 0 717.824 409.6H151.04zM151.04 665.6h-0.512a39.8848 39.8848 0 0 0 0.512 79.872h260.096A39.9872 39.9872 0 0 0 410.624 665.6H151.04z\" fill=\"#FFFFFF\" p-id=\"2004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/add.svg
// module id = 58n+
// module chunks = 27